import _ from "lodash";
import React, { Component } from "react";
import RSVP from "react-rsvp-module";
import Page from "./Page";
import translations from "./locales";
import getLocale from "./helpers/getLocale";
import getRsvpStep from "./helpers/getRsvpStep";
import { EarlyAccessProducts } from "./components";

class App extends Component {
  constructor(props) {
    super(props);
    let locale = getLocale();
    this.state = {
      locale,
      rsvpStep: getRsvpStep()
    };
  }

  componentDidMount() {
    this.updateLanguage(this.state.locale);
    window.addEventListener(
      "hashchange",
      this.locationChanged.bind(this),
      false
    );
  }

  componentWillUnmount() {
    window.removeEventListener(
      "hashchange",
      this.locationChanged.bind(this),
      false
    );
  }

  locationChanged = () => {
    this.setState({
      rsvpStep: getRsvpStep()
    });
  };

  updateLanguage = (locale, cb = undefined) => {
    // This assumes we're using window.location.hash for routing!!!
    const { hash } = window.location;
    const re = new RegExp(`/(${process.env.REACT_APP_AVAILABLE_LOCALES})/`);
    window.location.hash =
      hash === "#/" ? `#/${locale}/` : hash.replace(re, `/${locale}/`);
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("lang", locale);
    this.setState(
      {
        locale
      },
      () => _.isFunction(cb) && cb()
    );
  };

  openLanguageSwitcher = () => {
    const locale = this.state.locale;
    const title = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.language_switcher.title"
    );
    const enLabel = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.language_switcher.button.en_label"
    );
    const cnLabel = _.get(
      translations[locale],
      "it_rsvp_30th_anniv.language_switcher.button.cn_label"
    );
    this.rsvp.openModal({
      small: true,
      title: title,
      className: 'modal-box--language-switcher',
      buttons: [
        {
          text: enLabel,
          onClick: () =>
            this.updateLanguage("en", () => this.rsvp.closeModal()),
          secondary: true,
          className: 'modal-button--en'
        },
        {
          text: cnLabel,
          onClick: () =>
            this.updateLanguage("zh-CN", () => this.rsvp.closeModal()),
          secondary: true,
          className: 'modal-button--zh-cn'
        }
      ]
    });
  };

  rsvp = null;

  _renderProducts = () => <EarlyAccessProducts clickable={true} />;

  render() {
    // console.debug('rsvpSteprsvpStep', this.state.rsvpStep);
    return (
      <Page openLanguageSwitcher={this.openLanguageSwitcher}>
        <div className="rsvp-module">
          <div className={`rsvp_step--${this.state.rsvpStep}`}>
            <RSVP
              ref={ref => (this.rsvp = ref)}
              locale={this.state.locale}
              onLocaleChange={this.updateLanguage}
              translations={translations}
              // completePageCustomElement={this._renderProducts()}
              completePageQrCodeProps={{
                bgColor: '#000000',
                fgColor: '#ffffff',
                renderAs: 'canvas', // 'canvas' or 'svg'
                size: 200,
                level: 'L', // 'L' 'M' 'Q' 'H'
              }}
            />
          </div>
        </div>
      </Page>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js